import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";

import { setPlanValue } from "../../business/models/Plan/planActions";

import {
  getPlanPropertyValue,
  getPlanPropertyPreviousValue,
  getPlanPropertyErrorsByProperty,
  selectPlanDisplayErrors,
  getPlanPropertyOptions,
  isDisabled
} from "../../business/models/Plan/planSelectors";

import Controls from "./controls/index";

const PlanField = props => {
  const { name, component, ...componentProps } = props;
  const dispatch = useDispatch();
  const options = useSelector(state => getPlanPropertyOptions(state, props));
  const value = useSelector(state => getPlanPropertyValue(state, props));
  const prevValue = useSelector(state =>
    getPlanPropertyPreviousValue(state, props)
  );
  const errors = useSelector(state =>
    getPlanPropertyErrorsByProperty(state, props)
  );
  const displayErrors = useSelector(selectPlanDisplayErrors);
  const disabled = useSelector(state => isDisabled(state, props));
  const handleChange = val => {
    dispatch(setPlanValue({ [name]: val }));
  };

  const Control = Controls[component];
  return (
    <Control
      component={component}
      {...componentProps}
      onChange={handleChange}
      value={value}
      prevValue={prevValue}
      errors={errors}
      displayErrors={displayErrors}
      options={options}
      disabled={disabled}
    />
  );
};

PlanField.propTypes = {
  component: PropTypes.oneOf([
    "text",
    "date",
    "decimal",
    "autocomplete",
    "checkbox"
  ]),
  name: PropTypes.string.isRequired
};

export default PlanField;
